import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import { setFiltro, getListaAnaliseCativoMercadoLivreMensal, getListaAnaliseCativoMercadoLivrePeriodo, atualizarListasAnaliseCativoMercadoLivrePeriodo } from "../analiseActions";
import { gerarRelatorio } from "../../fatura/faturaActions.js";
import { montarGraficoGroupStackedColumn } from "../../common/graficos/montarGraficoGroupStackedColumn.js";
import * as am4core from "@amcharts/amcharts4/core";
import { montarGraficoPizza } from "../../common/graficos/montarGraficoPizza.js";
import Row from "../../common/layout/row.jsx";
import Grid from "../../common/layout/grid.jsx";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import Button from "../../common/button/button.jsx";
import Table from "../../common/table/table.jsx";
import THead from "../../common/table/tHead.jsx";
import Tr from "../../common/table/tr.jsx";
import Th from "../../common/table/th.jsx";
import TBody from "../../common/table/tBody.jsx";
import Td from "../../common/table/td.jsx";
import DateFormat from "../../common/dateFormat/DateFormat.js";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import { bandeiras } from "../../assets/icons.js";
import AlertIcon from "../../common/alertIcon/alertIcon.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import { Loading } from "../../common/loading/loading.jsx";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import { setInfo } from "../../common/toast/toast.jsx";
import { convertToBase64 } from "../../utils/convertToBase64.js";

import iconeImposto from "../../assets/images/imposto.png";

function analiseMercadoLivre(props) {
    if (!props.visible) return null;

    const {
        state,
        setAguardando,
        gerarRelatorio,
        setFiltro,
        filtro,
        listaUnidadeConsumidora,
        listaGraficoCustoMercadoLivreMensal,
        listaGraficoCustoMercadoLivrePeriodo,
        listaGraficoCustoMercadoLivreTipo,
        listaTarifasAneelMensal,
        listaTarifasAneelPeriodo,
        getListaAnaliseCativoMercadoLivreMensal,
        getListaAnaliseCativoMercadoLivrePeriodo,
    } = props;

    const [modalDetalhesImpostosAberto, setModalDetalhesImpostosAberto] = useState();
    const [graficoCustoMercadoLivreMensal, setGraficoCustoMercadoLivreMensal] = useState();
    const [graficoCustoMercadoLivrePeriodo, setGraficoCustoMercadoLivrePeriodo] = useState();
    const [graficoCustoMercadoLivreTipo, setGraficoCustoMercadoLivreTipo] = useState();
    const [exibirTabelaTarifasANEEL, setExibirTabelaTarifasANEEL] = useState(null);

    const scrollRef = useRef(null);
    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);

    useEffect(() => {
        const el = scrollRef.current;
        if (el && window.innerWidth < 768) {
            // Centraliza o scroll horizontal
            el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
        }

        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;
            if (filtro.unidades_consumidoras.length !== 1) {
                return setAguardando(false);
            }
            await Promise.all([getListaAnaliseCativoMercadoLivreMensal(), getListaAnaliseCativoMercadoLivrePeriodo()]);
            setAguardando(false);
        };
        buscarDados();
    }, [state.aguardando]);

    useEffect(() => {
        atualizarListaGraficoCustoMercadoLivrePeriodo();
    }, [JSON.stringify(listaGraficoCustoMercadoLivrePeriodo)]);

    useEffect(() => {
        atualizarListaGraficoCustoMercadoLivreTipo();
    }, [JSON.stringify(listaGraficoCustoMercadoLivreTipo)]);

    useEffect(() => {
        atualizarListaGraficoCustoMercadoLivreMensal();
    }, [JSON.stringify(listaGraficoCustoMercadoLivreMensal)]);

    // useEffect(() => {
    //     if (!exibirTabelaTarifasANEEL) return;
    //     window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    // }, [exibirTabelaTarifasANEEL]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoCustoMercadoLivreMensal();
        atualizarListaGraficoCustoMercadoLivreTipo();
        atualizarListaGraficoCustoMercadoLivrePeriodo();
    }
    function desmontarTodosGraficos() {
        if (graficoCustoMercadoLivreMensal) graficoCustoMercadoLivreMensal.dispose();
        if (graficoCustoMercadoLivreTipo) graficoCustoMercadoLivreTipo.dispose();
        if (graficoCustoMercadoLivrePeriodo) graficoCustoMercadoLivrePeriodo.dispose();
    }

    function mapearListaGraficoColunasAgrupadas(lista) {
        return {
            dados: [...lista],
            valuesAndNames: [
                { value: "valor_cativo", name: "No cativo", stacked: false, linePattern: false },
                { value: "valor_mercado_livre", name: "No livre", stacked: false, linePattern: false },
                { value: "valor_economia", name: "Economia", stacked: true, linePattern: true },
            ],
        };
    }

    function atualizarListaGraficoCustoMercadoLivreMensal() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoCustoMercadoLivreMensal);
        const graficoCustoMercadoLivreMensalAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: [am4core.color("#0084ff"), am4core.color("#00d185"), am4core.color("#abffe1")],
            },
            component: graficoCustoMercadoLivreMensal,
            nome: "graficoCustoMercadoLivreMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: `Custo Mensal ${filtro.ano_mercado_livre} (R$)`,
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: "R$",
            sufixo: "",
            dimensions: "2D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
            bullets: true,
            individualBullets: true,
            nameSerieBullets: "No cativo",
            dxIcone: 25,
        });

        setGraficoCustoMercadoLivreMensal(graficoCustoMercadoLivreMensalAtualizado);
    }

    function atualizarListaGraficoCustoMercadoLivrePeriodo() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoCustoMercadoLivrePeriodo);
        const graficoCustoMercadoLivrePeriodoAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: [am4core.color("#0088ff"), am4core.color("#00d185"), am4core.color("#87eac7")],
            },
            component: graficoCustoMercadoLivrePeriodo,
            nome: "graficoCustoMercadoLivrePeriodo",
            dados,
            category: "periodo",
            valuesAndNames,
            titulo: "Custo Total no Período Selecionado (R$)",
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: "R$",
            sufixo: "",
            dimensions: "2D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
            bullets: true,
            centralizarVerticalmente: true
        });

        setGraficoCustoMercadoLivrePeriodo(graficoCustoMercadoLivrePeriodoAtualizado);
    }

    function atualizarListaGraficoCustoMercadoLivreTipo() {
        //agrupa por categoriao (No cativo, No livre, Economia)

        const graficoCustoMercadoLivreTipoAtualizado = montarGraficoPizza({
            state: {
                cores: [am4core.color("#fdff6a"), am4core.color("#12ffb8"), am4core.color("#00d5ff"), am4core.color("#f49e13"), am4core.color("#ff5e76")],
            },
            component: graficoCustoMercadoLivreTipo,
            nome: "graficoCustoMercadoLivreTipo",
            dados: listaGraficoCustoMercadoLivreTipo,
            category: "tipo",
            value: "valor",
            titulo: "Detalhamento dos valores pagos de Mercado Livre (R$)",
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: "R$",
            sufixo: "",
            exportar: false,
        });

        setGraficoCustoMercadoLivreTipo(graficoCustoMercadoLivreTipoAtualizado);
    }

    const ucFiltrada = filtro.unidades_consumidoras.length == 1 ? listaUnidadeConsumidora.find((uc) => uc.id == filtro.unidades_consumidoras[0].value) : null;
    const ucFiltradaAzul = !!(ucFiltrada && ucFiltrada.id_modalidade_tarifaria == 2);
    const ucFiltradaIrrigante = !!(ucFiltrada && ucFiltrada.irrigante);
    const competenciaInicioMercadoLivre = ucFiltrada ? ucFiltrada.competencia_inicio_mercado_livre : null;
    const primeiroMesMercadoLivre = competenciaInicioMercadoLivre ? String(competenciaInicioMercadoLivre).substring(4, 6) : null;

    const listaMensalFiltrada = listaGraficoCustoMercadoLivreMensal.filter(
        (item) => (!competenciaInicioMercadoLivre || item.competencia >= competenciaInicioMercadoLivre) && item.valor_mercado_livre > 0
    );

    /**
     * @param {string} mes Ex: '01'
     * @returns {boolean}
     */
    function verificarInicioMercadoLivre(mes) {
        return competenciaInicioMercadoLivre && mes && filtro.ano_mercado_livre && String(competenciaInicioMercadoLivre) === `${filtro.ano_mercado_livre}${mes}`;
    }

    const cabecalho = (
        <THead>
            <Tr>
                <Th style={{ fontSize: "0.8rem", textAlign: "center" }} colSpan={17} alignCenter backgroundColor="#0090ff">
                    Tarifas ANEEL Utilizadas{" "}
                </Th>
            </Tr>
            <Tr>
                <Th maxWidth={70} style={{ fontSize: "0.8rem" }} alignCenter>
                    Mês
                </Th>
                <Th minWidth={80} width={80} maxWidth={80} style={{ fontSize: "0.8rem" }} alignCenter>
                    Data Emissão NF
                </Th>
                <Th minWidth={80} width={80} maxWidth={80} style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#7b99c8">
                    Data Início Vigência
                </Th>
                <Th minWidth={80} width={80} maxWidth={80} style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#475e8e">
                    Data Fim Vigência
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#1d2a41" alignCenter>
                    FI
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Energia FP
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Tarifa Energia FP
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#30303a" alignCenter>
                    Custo Energia FP
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Energia Ponta
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Tarifa Energia Ponta
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#30303a" alignCenter>
                    Custo Energia Ponta
                </Th>
                {ucFiltradaIrrigante && (
                    <Th style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                        Energia Reservado
                    </Th>
                )}
                {ucFiltradaIrrigante && (
                    <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                        Tarifa Energia Reserv.
                    </Th>
                )}
                {ucFiltradaIrrigante && (
                    <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#30303a" alignCenter>
                        Custo Energia Reserv.
                    </Th>
                )}
                {ucFiltradaAzul && (
                    <Th style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                        Demanda Ponta
                    </Th>
                )}
                {ucFiltradaAzul && (
                    <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                        Tarifa Demanda Ponta
                    </Th>
                )}
                {ucFiltradaAzul && (
                    <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#30303a" alignCenter>
                        Custo Demanda Ponta
                    </Th>
                )}
                <Th style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Demanda FP
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Tarifa Demanda FP
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#30303a" alignCenter>
                    Custo Demanda FP
                </Th>
                <Th minWidth={120} style={{ fontSize: "0.8rem" }} backgroundColor="#2a2931" alignCenter>
                    Custo de Bandeiras
                </Th>
                <Th minWidth={100} style={{ fontSize: "0.8rem" }} backgroundColor="#2a2931" alignCenter>
                    Total Fatura Cativo Simulado
                </Th>
                <Th minWidth={80} width={80} maxWidth={80} style={{ fontSize: "0.8rem" }} backgroundColor="#3b3b46" alignCenter>
                    Detalhes de Impostos
                </Th>
            </Tr>
        </THead>
    );

    async function handleExport({ graficosAtivos }) {
        setLoading(true);

        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, zoom, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = zoom || "0.90"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1200 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, zoom = 1 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = 0.7 * (zoom / 1); // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase()}px`;
                el.style.zoom = zoom || "1"; // ajusta de verdade o tamanho do elemento
            }
        };

        const formatarGrafico = ({ el, zoom }) => {
            if (el) {
                el.style.fontSize = "1.1rem";
                calcularWidthGrafico({ el, zoom });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
                const titulo = el.querySelectorAll("tspan");
                titulo.forEach((el, i) => {
                    if (el.textContent.includes("Custo Mensal") || el.textContent.includes("Custo Total") || el.textContent.includes("Detalhamento")) {
                        el.style.marginTop = "3rem";
                        el.style.fontSize = "1.6rem";
                        el.style.fontWeight = "bold";
                        el.setAttribute("x", el.textContent.length * 4 + "px"); // centraliza no meio do SVG
                        el.setAttribute("text-anchor", "middle");
                    }
                });
            }
        };
        const formatarTabela = ({ el, zoom, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el, zoom });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula, i) => {
                    if (heightCelula) {
                        celula.style.height = heightCelula;
                    }
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = i == 0 ? "center" : "left";
                    celula.style.fontSize = "1.2rem";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };

        const exibirTagOculta = ({ el, textAlign = "left", titulo = false }) => {
            if (el) {
                const tamanhoBase = titulo ? 1.6 : 1; // tamanho base
                const zoomPadrao = 1; // zoom padrão para tamanho 1
                const zoom = window.innerWidth < 768 ? zoomPadrao * 0.7 : zoomPadrao; // menor em tela pequena

                const tamanhoFinal = tamanhoBase * zoom;

                el.style.color = "#FFFFFF";
                el.style.fontSize = tamanhoFinal + "rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "10px";
                el.style.padding = "5px";
                el.style.textAlign = textAlign;
            }
        };

        if (contentCardRef.current) {
            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const ucSelecionada = contentCardRef.current.querySelector("#ucSelecionada");
            const graficoCustoMercadoLivreMensal = contentCardRef.current.querySelector("#graficoCustoMercadoLivreMensal");
            const tabelaCustoMercadoLivreMensal = contentCardRef.current.querySelector("#tabelaCustoMercadoLivreMensal");
            const tarifasCustoMercadoLivreMensalTabela = contentCardRef.current.querySelector("#tarifasCustoMercadoLivreMensalTabela");

            const graficoCustoMercadoLivrePeriodo = contentCardRef.current.querySelector("#graficoCustoMercadoLivrePeriodo");
            const graficoCustoMercadoLivreTipo = contentCardRef.current.querySelector("#graficoCustoMercadoLivreTipo");
            const tarifasPeriodo = contentCardRef.current.querySelector("#tarifasPeriodo");

            exibirTagOculta({ el: ucSelecionada, titulo: true });
            formatarGrafico({ el: graficoCustoMercadoLivreMensal });
            formatarTabela({ el: tabelaCustoMercadoLivreMensal });
            formatarTabela({ el: tarifasCustoMercadoLivreMensalTabela, zoom: 0.8 });
            formatarGrafico({ el: graficoCustoMercadoLivrePeriodo, zoom: 0.7 });
            formatarGrafico({ el: graficoCustoMercadoLivreTipo, zoom: 0.7 });
            formatarTabela({ el: tarifasPeriodo, zoom: 0.8 });

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="width:100%; height:100%; display:flex; flex-direction:column; border: 1px solid #DDD;font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                        <img src="${base64Cabecalho}" width="100%" />
                        <div style="margin-top:-60px; margin-left:10px;">${ucSelecionada.outerHTML}</div>
                    </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                <img src="${base64Rodape}" width="100%" />
                            </div>
                        </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoTabelaCustoMensal =
                graficosAtivos.graficoCustoMercadoLivreMensal && graficoCustoMercadoLivreMensal && tabelaCustoMercadoLivreMensal
                    ? `<div style="width:100%; height:45%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                      graficoCustoMercadoLivreMensal.outerHTML +
                      tabelaCustoMercadoLivreMensal.outerHTML +
                      "</div>"
                    : "";

            const htmlTarifasCustoMensal =
                graficosAtivos.tarifasCustoMercadoLivreMensal && tarifasCustoMercadoLivreMensalTabela
                    ? `<div style="width:100%; height:40%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                      tarifasCustoMercadoLivreMensalTabela.outerHTML +
                      "</div>"
                    : "";

            const htmlTarifasCustoPeriodo =
                graficosAtivos.tarifasPeriodo && tarifasPeriodo
                    ? `<div style="width:100%; height:40%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d">` +
                      tarifasPeriodo.outerHTML +
                      "</div>"
                    : "";

            const ocultarTabelaTarifas = !htmlTarifasCustoMensal && !htmlTarifasCustoPeriodo;

            const htmlGraficosCustoPeriodo =
                graficosAtivos.graficosPeriodo && graficoCustoMercadoLivrePeriodo && graficoCustoMercadoLivreTipo
                    ? `<div style="width:100%; height:${
                          ocultarTabelaTarifas ? "40%" : "45%"
                      }; display:flex; align-items:center; justify-content:center; margin-bottom:6px; background-color:#30303d; padding-left:5%">` +
                      graficoCustoMercadoLivrePeriodo.outerHTML +
                      graficoCustoMercadoLivreTipo.outerHTML +
                      "</div>"
                    : "";

            let html = "";
            if (ocultarTabelaTarifas) {
                //se nao vai ver tarifas mostra em um apagina
                html += htmlCabecalho;
                html += htmlGraficoTabelaCustoMensal + htmlGraficosCustoPeriodo + '<div style="flex-grow:1"></div>';
                html += htmlRodape;
            } else {
                html += htmlCabecalho;
                html += htmlGraficoTabelaCustoMensal + htmlTarifasCustoMensal + '<div style="flex-grow:1"></div>';
                html += htmlRodape;
                html += htmlCabecalho;
                html += htmlGraficosCustoPeriodo + htmlTarifasCustoPeriodo + '<div style="flex-grow:1"></div>';
                html += htmlRodape;
            }

            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    return (
        <div ref={contentCardRef}>
            <ContentCardBody
                style={{
                    color: "#FFF",
                    backgroundColor: "#30303d",
                    overflowX: "auto",
                }}
            >
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                            text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                            title="Exportar"
                            type={"light"}
                            icon={"fa fa-file-export"}
                            event={() => {
                                if (filtro.unidades_consumidoras.length !== 1) {
                                    return setInfo("Selecione uma única UC e clique em atualizar antes de exportar");
                                }
                                setExibirTabelaTarifasANEEL(true);
                                setModalExportacaoAberto(true);
                            }}
                        />
                    </Grid>
                </Row>
                {modalDetalhesImpostosAberto ? (
                    <ModalAlert
                        handleClose={() => {
                            setModalDetalhesImpostosAberto(false);
                        }}
                    >
                        <div className="d-flex justify-content-center align-items-center">
                            <Table responsive>
                                <THead>
                                    <Tr>
                                        <Th colSpan={3} color="#222" alignCenter>
                                            <h5>Detalhes de Impostos</h5>
                                        </Th>
                                    </Tr>
                                    <Tr>
                                        <Th color="#222">Descrição</Th>
                                        <Th color="#222" alignCenter>
                                            Alíquota
                                        </Th>
                                        <Th color="#222" alignCenter>
                                            Valor Resultante
                                        </Th>
                                    </Tr>
                                </THead>
                                <TBody>
                                    <Tr>
                                        <Td color="#222">ICMS</Td>
                                        <Td width={200} color="#222" fontSize="0.8rem" alignCenter paddingLeft={4}>
                                            {adicionarPontosMilhar(modalDetalhesImpostosAberto.aliquota_icms) + "%"}
                                        </Td>
                                        <Td width={200} color="#222" fontSize="0.8rem" alignCenter paddingLeft={4}>
                                            {"R$ " + adicionarPontosMilhar(parseFloat(modalDetalhesImpostosAberto.resultado_icms_cativo || 0))}
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td color="#222">PIS/Pasep</Td>
                                        <Td width={200} color="#222" fontSize="0.8rem" alignCenter paddingLeft={4}>
                                            {adicionarPontosMilhar(modalDetalhesImpostosAberto.aliquota_pis_pasep) + "%"}
                                        </Td>
                                        <Td width={200} color="#222" fontSize="0.8rem" alignCenter paddingLeft={4}>
                                            {"R$ " + adicionarPontosMilhar(parseFloat(modalDetalhesImpostosAberto.resultado_pis_pasep_cativo || 0))}
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td color="#222">Cofins</Td>
                                        <Td width={200} color="#222" fontSize="0.8rem" alignCenter paddingLeft={4}>
                                            {adicionarPontosMilhar(modalDetalhesImpostosAberto.aliquota_cofins) + "%"}
                                        </Td>
                                        <Td width={200} color="#222" fontSize="0.8rem" alignCenter paddingLeft={4}>
                                            {"R$ " + adicionarPontosMilhar(parseFloat(modalDetalhesImpostosAberto.resultado_cofins_cativo || 0))}
                                        </Td>
                                    </Tr>
                                </TBody>
                            </Table>
                        </div>
                    </ModalAlert>
                ) : null}
                {modalExportacaoAberto ? (
                    <ModalAlert
                        handleClose={() => {
                            setExibirTabelaTarifasANEEL(false);
                            setModalExportacaoAberto(false);
                        }}
                    >
                        <ExportAnalise />
                    </ModalAlert>
                ) : null}
                {loading ? (
                    <>
                        <Loading />
                        <div style={{ height: "100vh", width: "100%" }}></div>
                    </>
                ) : null}

                <div id="ucSelecionada" style={{ visibility: "hidden", marginBottom: 0, marginTop: 0, padding: 0, fontWeight: "bold", fontSize: "1.6rem", textAlign: "center" }}>
                    {ucFiltrada ? `Unidade Consumidora: ${ucFiltrada.valor}` : ""}
                </div>
                <div style={{ minWidth: "890px" }}>
                    <div id="graficoCustoMercadoLivreMensal" style={{ width: "100%", height: "400px" }}></div>

                    <Table responsive id="tabelaCustoMercadoLivreMensal">
                        <THead>
                            {primeiroMesMercadoLivre ? (
                                <Tr>
                                    <Th></Th>
                                    {verificarInicioMercadoLivre("01") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}

                                    {verificarInicioMercadoLivre("02") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("03") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("04") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("05") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("06") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("07") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("08") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("09") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("10") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("11") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    {verificarInicioMercadoLivre("12") ? (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor="#11c976">
                                            Início de M.L.
                                        </Th>
                                    ) : (
                                        <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                    )}
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter></Th>
                                </Tr>
                            ) : null}
                            <Tr>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                    Descrição
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("01") ? "#11c976" : null}>
                                    Janeiro
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("02") ? "#11c976" : null}>
                                    Fevereiro
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("03") ? "#11c976" : null}>
                                    Março
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("04") ? "#11c976" : null}>
                                    Abril
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("05") ? "#11c976" : null}>
                                    Maio
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("06") ? "#11c976" : null}>
                                    Junho
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("07") ? "#11c976" : null}>
                                    Julho
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("08") ? "#11c976" : null}>
                                    Agosto
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("09") ? "#11c976" : null}>
                                    Setembro
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("10") ? "#11c976" : null}>
                                    Outubro
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("11") ? "#11c976" : null}>
                                    Novembro
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={verificarInicioMercadoLivre("12") ? "#11c976" : null}>
                                    Dezembro
                                </Th>
                                <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                    Média
                                </Th>
                            </Tr>
                        </THead>
                        <TBody>
                            <Tr>
                                <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                    Fatura Mercado Cativo
                                </Td>
                                {listaGraficoCustoMercadoLivreMensal.map((item, i) => (
                                    <Td
                                        fontSize="0.8rem"
                                        alignCenter
                                        paddingLeft={4}
                                        key={item.mes}
                                        color="#fff"
                                        backgroundColor={verificarInicioMercadoLivre(i + 1 < 10 ? "0" + (i + 1) : i + 1) ? "#11c976" : null}
                                    >
                                        <div title={`Impostos: R$ ${adicionarPontosMilhar(item.valor_imposto_cativo || 0, 6)}`}>
                                            {parseFloat(item.valor_cativo || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </div>
                                    </Td>
                                ))}
                                <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                    {(listaMensalFiltrada.length //divide pela qtd de elementos com valor
                                        ? listaMensalFiltrada.reduce((acc, item) => (acc += parseFloat(item.valor_cativo) || 0), 0) / listaMensalFiltrada.length
                                        : 0
                                    )
                                        .toFixed(2)
                                        .replace(".", ",")}
                                </Td>
                            </Tr>
                            <Tr>
                                <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                    Fatura Mercado Livre
                                </Td>
                                {listaGraficoCustoMercadoLivreMensal.map((item, i) => (
                                    <Td
                                        fontSize="0.8rem"
                                        alignCenter
                                        paddingLeft={4}
                                        key={item.mes}
                                        color="#fff"
                                        backgroundColor={verificarInicioMercadoLivre(i + 1 < 10 ? "0" + (i + 1) : i + 1) ? "#11c976" : null}
                                    >
                                        {parseFloat(item.valor_mercado_livre || 0)
                                            .toFixed(2)
                                            .replace(".", ",")}
                                    </Td>
                                ))}
                                <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                    {(listaMensalFiltrada.length //divide pela qtd de elementos com valor
                                        ? listaMensalFiltrada.reduce((acc, item) => (acc += parseFloat(item.valor_mercado_livre) || 0), 0) / listaMensalFiltrada.length
                                        : 0
                                    )
                                        .toFixed(2)
                                        .replace(".", ",")}
                                </Td>
                            </Tr>
                            <Tr>
                                <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                    Economia
                                </Td>
                                {listaGraficoCustoMercadoLivreMensal.map((item, i) => (
                                    <Td
                                        fontSize="0.8rem"
                                        alignCenter
                                        paddingLeft={4}
                                        key={item.mes}
                                        color="#fff"
                                        backgroundColor={verificarInicioMercadoLivre(i + 1 < 10 ? "0" + (i + 1) : i + 1) ? "#11c976" : null}
                                    >
                                        {parseFloat(item.valor_economia || 0)
                                            .toFixed(2)
                                            .replace(".", ",")}
                                    </Td>
                                ))}
                                <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                    {(listaMensalFiltrada.length //divide pela qtd de elementos com valor
                                        ? listaMensalFiltrada.reduce((acc, item) => (acc += parseFloat(item.valor_economia) || 0), 0) / listaMensalFiltrada.length
                                        : 0
                                    )
                                        .toFixed(2)
                                        .replace(".", ",")}
                                </Td>
                            </Tr>
                        </TBody>
                    </Table>
                </div>
            </ContentCardBody>
            <ContentCardBody
                style={{
                    color: "#FFF",
                    backgroundColor: "#30303d",
                    overflowX: "auto",
                }}
            >
                <Row>
                    <Grid cols="12 12 12 12" style={{ padding: 10 }}>
                        <Button
                            text={
                                <div>
                                    <span style={{ borderRadius: "50%", margin: 6, padding: "5px 11px", border: "1px solid #FFF" }}>
                                        <i className="fa fa-info" />
                                    </span>
                                    <span>{exibirTabelaTarifasANEEL ? "Ocultar" : "Ilustrar"} Tabela Detalhe com Tarifas ANEEL</span>
                                </div>
                            }
                            hoverStyle={{ filter: "brightness(1.1)" }}
                            style={{
                                margin: 0,
                                backgroundColor: exibirTabelaTarifasANEEL ? "#f53650" : "#00a2ff",
                                color: "#FFF",
                            }}
                            event={() => {
                                setExibirTabelaTarifasANEEL(!exibirTabelaTarifasANEEL);
                            }}
                        />
                    </Grid>
                </Row>
                {exibirTabelaTarifasANEEL && (
                    <Row style={{ margin: 0, color: "#FFF" }}>
                        <Table responsive id="tarifasCustoMercadoLivreMensalTabela">
                            {cabecalho}
                            <TBody>{renderizarTabelaTarifasAneel(listaTarifasAneelMensal)}</TBody>
                        </Table>
                    </Row>
                )}
            </ContentCardBody>
            <ContentCard style={{ color: "#fff", padding: 8, gap: 15 }}>
                <Row style={{ marginTop: 20 }}>
                    <Grid cols="12 12 2 2">
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                            <DatePicker
                                variant="inline"
                                openTo="year"
                                views={["year", "month"]}
                                label="Competência Inicial"
                                autoOk
                                value={
                                    filtro.competencia_inicial_mercado_livre
                                        ? `${String(filtro.competencia_inicial_mercado_livre).substring(0, 4)}/${String(filtro.competencia_inicial_mercado_livre).substring(
                                              4,
                                              6
                                          )}/01 12:00:00`
                                        : null
                                }
                                onChange={(value) => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_inicial_mercado_livre: value
                                            ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                            : null,
                                    });
                                }}
                                fullWidth
                                InputProps={{
                                    style: {
                                        color: "#222", // cor do texto digitado
                                    },
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "#222", // cor do label/flutuante
                                    },
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid cols="12 12 2 2">
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                            <DatePicker
                                variant="inline"
                                openTo="year"
                                views={["year", "month"]}
                                label="Competência Final"
                                autoOk
                                value={
                                    filtro.competencia_final_mercado_livre
                                        ? `${String(filtro.competencia_final_mercado_livre).substring(0, 4)}/${String(filtro.competencia_final_mercado_livre).substring(
                                              4,
                                              6
                                          )}/01 12:00:00`
                                        : null
                                }
                                onChange={(value) => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_final_mercado_livre: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                    });
                                }}
                                fullWidth
                                InputProps={{
                                    style: {
                                        color: "#222", // cor do texto digitado
                                    },
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "#222", // cor do label/flutuante
                                    },
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid cols="12 12 2 2" style={{ paddingTop: 10 }}>
                        <Button
                            text="Analisar"
                            type={"primary"}
                            icon={"fa fa-sync"}
                            style={{ margin: window.innerWidth < 768 ? 0 : null }}
                            event={getListaAnaliseCativoMercadoLivrePeriodo}
                        />
                    </Grid>
                </Row>

                <ContentCardBody style={{ backgroundColor: "#30303d" }}>
                    <Row style={{ margin: 0 }}>
                        <Grid cols="12 12 12 6" style={{ paddingTop: 10, display: "flex", width: "100%", justifyContent: "center" }}>
                            <div
                                id="graficoCustoMercadoLivrePeriodo"
                                style={{
                                    width: "100%",
                                    height: "400px",
                                }}
                            ></div>
                        </Grid>
                        <Grid cols="12 12 12 6" style={{ paddingTop: 10, paddingInline: 0, display: "flex", width: "100%", justifyContent: "center" }}>
                            <div
                                ref={scrollRef}
                                className="custom-scroll"
                                style={{ overflowX: "auto", display: "flex", width: "100%", justifyContent: window.innerWidth < 992 ? "left" : "center", marginInline: 0 }}
                            >
                                <div
                                    id="graficoCustoMercadoLivreTipo"
                                    style={{
                                        width: "100%",
                                        minWidth: window.innerWidth < 992 ? 1200 : 600,
                                        height: "400px",
                                    }}
                                ></div>
                            </div>
                        </Grid>
                    </Row>
                    <Row>
                        <Grid cols="12 12 12 12" style={{ padding: 10 }}>
                            {competenciaInicioMercadoLivre ? (
                                listaGraficoCustoMercadoLivrePeriodo.length > 0 && (
                                    <div>
                                        <div
                                            style={{
                                                display: "flex",
                                                padding: 4,
                                                fontWeight: "bold",
                                                lineHeight: "30px",
                                                backgroundColor: "#1689db",
                                                fontSize: "1rem",
                                                color: "#FFF",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div>
                                                <i className="fas fa-arrow-right"></i>{" "}
                                                {" A unidade migrou para mercado livre em: " +
                                                    String(competenciaInicioMercadoLivre).substring(4, 6) +
                                                    "/" +
                                                    String(competenciaInicioMercadoLivre).substring(0, 4)}
                                            </div>
                                            {competenciaInicioMercadoLivre > filtro.competencia_inicial_mercado_livre && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        fontWeight: 500,
                                                        color: "#f00",
                                                        marginLeft: 15,
                                                        paddingInline: 5,
                                                        borderRadius: 10,
                                                        background: "#000",
                                                    }}
                                                >
                                                    <span className="pl-2" style={{ marginTop: -3 }}>
                                                        <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                    </span>
                                                    <span className="pl-2">Verificar período selecionado</span>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ padding: 4, color: "#ffff04", backgroundColor: "#47534f" }}>
                                            Faturas anteriores à migração não foram contabilizadas no gráfico
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div style={{ display: "flex", fontWeight: 500, lineHeight: "30px", color: "#ff0436", backgroundColor: "#171717" }}>
                                    <span className="pl-2">
                                        <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                    </span>
                                    <span className="pl-2" style={{ paddingTop: 5 }}>
                                        Não foi cadastrada data de início de mercado livre
                                    </span>
                                </div>
                            )}
                        </Grid>
                    </Row>
                    <Row style={{ margin: 0 }}>
                        <Table responsive id="tarifasPeriodo">
                            {cabecalho}
                            <TBody>{renderizarTabelaTarifasAneel(listaTarifasAneelPeriodo)}</TBody>
                        </Table>
                    </Row>
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function renderizarTabelaTarifasAneel(lista) {
        return lista.map((item, i) => {
            return (
                <Tr key={i}>
                    <Td alignCenter fontSize="0.8rem" color="#fff">
                        <div>{String(item.competencia).substring(4, 6) + "/" + String(item.competencia).substring(0, 4)}</div>
                    </Td>
                    <Td
                        fontSize="0.8rem"
                        alignCenter
                        paddingLeft={4}
                        color={item.data_emissao_nota_fiscal ? "#FFF" : "#fc3645"}
                        title={item.data_emissao_nota_fiscal ? null : "Data de emissão não foi identificada"}
                    >
                        <div>
                            {item.data_emissao_nota_fiscal
                                ? DateFormat.formatarDataSqlParaTela(item.data_emissao_nota_fiscal)
                                : "* 01/" + String(item.competencia).substring(4, 6) + "/" + String(item.competencia).substring(0, 4)}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#7b99c8" color="#fff">
                        <div>{DateFormat.formatarDataSqlParaTela(item.data_inicio_vigencia)}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#475e8e" color="#fff">
                        <div>{DateFormat.formatarDataSqlParaTela(item.data_fim_vigencia)}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#1d2a41" color="#fff">
                        <div
                            style={{ border: "1px solid #00EAFF", paddingBlock: 2 }}
                            title={`Fator multiplicativo para cálculo de impostos: ${adicionarPontosMilhar(item.fator_multiplicacao_imposto || 0, 6)}`}
                        >
                            {adicionarPontosMilhar(item.fator_multiplicacao_imposto, 6)}
                        </div>
                        <div
                            style={{ border: "1px solid #ff0051", paddingBlock: 2, marginTop: 2 }}
                            title={`Fator multiplicativo para cálculo de impostos (considerando alíquota ICMS zerada): ${adicionarPontosMilhar(
                                item.fator_multiplicacao_imposto_sem_icms || 0,
                                6
                            )}`}
                        >
                            {adicionarPontosMilhar(item.fator_multiplicacao_imposto_sem_icms, 6)}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <div>{adicionarPontosMilhar(item.quantidade_energia_fora_ponta) + " kWh"}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <div>{"TUSD: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_energia_fora_ponta_cativo_tusd || 0), 6)}</div>
                        <div>{"TE: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_energia_fora_ponta_cativo_te || 0), 6)}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#30303a" color="#fff">
                        <div
                            style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                            title={`Impostos: R$ ${adicionarPontosMilhar(
                                (item.resultado_energia_fora_ponta_cativo_tusd || 0) -
                                    (item.resultado_energia_fora_ponta_cativo_tusd || 0) / (item.fator_multiplicacao_imposto || 0),
                                6
                            )}`}
                        >
                            {"TUSD: R$ " + adicionarPontosMilhar(item.resultado_energia_fora_ponta_cativo_tusd, 2)}
                        </div>
                        <div
                            style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                            title={`Impostos: R$ ${adicionarPontosMilhar(
                                (item.resultado_energia_fora_ponta_cativo_te || 0) - (item.resultado_energia_fora_ponta_cativo_te || 0) / (item.fator_multiplicacao_imposto || 0),
                                6
                            )}`}
                        >
                            {"TE: R$ " + adicionarPontosMilhar(item.resultado_energia_fora_ponta_cativo_te, 2)}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <div>{adicionarPontosMilhar(item.quantidade_energia_ponta) + " kWh"}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <div>{"TUSD: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_energia_ponta_cativo_tusd || 0), 6)}</div>
                        <div>{"TE: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_energia_ponta_cativo_te || 0), 6)}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#30303a" color="#fff">
                        <div
                            style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                            title={`Impostos: R$ ${adicionarPontosMilhar(
                                (item.resultado_energia_ponta_cativo_tusd || 0) - (item.resultado_energia_ponta_cativo_tusd || 0) / (item.fator_multiplicacao_imposto || 0),
                                6
                            )}`}
                        >
                            {"TUSD: R$ " + adicionarPontosMilhar(item.resultado_energia_ponta_cativo_tusd, 2)}
                        </div>
                        <div
                            style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                            title={`Impostos: R$ ${adicionarPontosMilhar(
                                (item.resultado_energia_ponta_cativo_te || 0) - (item.resultado_energia_ponta_cativo_te || 0) / (item.fator_multiplicacao_imposto || 0),
                                6
                            )}`}
                        >
                            {"TE: R$ " + adicionarPontosMilhar(item.resultado_energia_ponta_cativo_te, 2)}
                        </div>
                    </Td>
                    {ucFiltradaIrrigante && (
                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                            <div>{adicionarPontosMilhar(item.quantidade_energia_reservado) + " kWh"}</div>
                        </Td>
                    )}
                    {ucFiltradaIrrigante && (
                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                            <div>{"TUSD: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_energia_reservado_cativo_tusd || 0), 6)}</div>
                            <div>{"TE: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_energia_reservado_cativo_te || 0), 6)}</div>
                        </Td>
                    )}
                    {ucFiltradaIrrigante && (
                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#30303a" color="#fff">
                            <div
                                style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                                title={`Impostos: R$ ${adicionarPontosMilhar(
                                    (item.resultado_energia_reservado_cativo_tusd || 0) -
                                        (item.resultado_energia_reservado_cativo_tusd || 0) / (item.fator_multiplicacao_imposto || 0),
                                    6
                                )}`}
                            >
                                {"TUSD: R$ " + adicionarPontosMilhar(item.resultado_energia_reservado_cativo_tusd, 2)}
                            </div>
                            <div
                                style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                                title={`Impostos: R$ ${adicionarPontosMilhar(
                                    (item.resultado_energia_reservado_cativo_te || 0) - (item.resultado_energia_reservado_cativo_te || 0) / (item.fator_multiplicacao_imposto || 0),
                                    6
                                )}`}
                            >
                                {"TE: R$ " + adicionarPontosMilhar(item.resultado_energia_reservado_cativo_te, 2)}
                            </div>
                        </Td>
                    )}
                    {ucFiltradaAzul && (
                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                            <div>{adicionarPontosMilhar(item.quantidade_demanda_ponta) + " kW"}</div>
                        </Td>
                    )}
                    {ucFiltradaAzul && (
                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                            <div>{"TUSD: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_demanda_ponta_cativo_tusd || 0), 6)}</div>
                            <div>{"TE: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_demanda_ponta_cativo_te || 0), 6)}</div>
                        </Td>
                    )}
                    {ucFiltradaAzul && (
                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#30303a" color="#fff">
                            <div
                                style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                                title={`Impostos: R$ ${adicionarPontosMilhar(item.valor_imposto_demanda_ponta_tusd, 6)}`}
                            >
                                {"TUSD: R$ " + adicionarPontosMilhar(item.resultado_demanda_ponta_cativo_tusd, 2)}
                            </div>
                            <div style={{ border: "1px solid #ad47f3", paddingBlock: 16 }} title={`Impostos: R$ ${adicionarPontosMilhar(item.valor_imposto_demanda_ponta_te, 6)}`}>
                                {"TE: R$ " + adicionarPontosMilhar(item.resultado_demanda_ponta_cativo_te, 2)}
                            </div>
                        </Td>
                    )}
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <div>{adicionarPontosMilhar(item.quantidade_demanda_fora_ponta) + " kW"}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <div>{"TUSD: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_demanda_fora_ponta_cativo_tusd || 0), 6)}</div>
                        <div>{"TE: R$ " + adicionarPontosMilhar(parseFloat(item.tarifa_demanda_fora_ponta_cativo_te || 0), 6)}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#30303a" color="#fff">
                        <div
                            style={{ border: "1px solid #ad47f3", paddingBlock: 16 }}
                            title={`Impostos: R$ ${adicionarPontosMilhar(item.valor_imposto_demanda_fora_ponta_tusd, 6)}`}
                        >
                            {"TUSD: R$ " + adicionarPontosMilhar(item.resultado_demanda_fora_ponta_cativo_tusd, 2)}
                        </div>
                        <div style={{ border: "1px solid #ad47f3", paddingBlock: 16 }} title={`Impostos: R$ ${adicionarPontosMilhar(item.valor_imposto_demanda_fora_ponta_te, 6)}`}>
                            {"TE: R$ " + adicionarPontosMilhar(item.resultado_demanda_fora_ponta_cativo_te, 2)}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#2a2931" color="#fff">
                        <div
                            style={{ border: "1px solid #ad47f3", padding: 4 }}
                            title={`Tarifa Bandeira: R$ ${adicionarPontosMilhar(item.tarifa_bandeira || 0, 6)} por kWh\nQtd. Energia: ${adicionarPontosMilhar(
                                item.quantidade_total_energia
                            )} kWh\nImpostos: R$ ${adicionarPontosMilhar(
                                (item.resultado_total_bandeira || 0) - (item.resultado_total_bandeira || 0) / (item.fator_multiplicacao_imposto || 0),
                                6
                            )}\nValor Total: R$ ${adicionarPontosMilhar(item.resultado_total_bandeira || 0, 2)}`}
                        >
                            <div>
                                <img src={bandeiras[item.icone]} alt="" width={25} height={25} />
                            </div>
                            {"R$ " + adicionarPontosMilhar(item.resultado_total_bandeira || 0, 2)}
                        </div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#2a2931" color="#fff">
                        <div>{"R$ " + adicionarPontosMilhar(item.resultado_total_cativo || 0, 2)}</div>
                    </Td>
                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} backgroundColor="#3b3b46" color="#fff">
                        <Button
                            title={"Detalhar impostos"}
                            style={{
                                width: 70,
                                height: 48,
                                padding: 0,
                            }}
                            text={
                                <div>
                                    <img src={iconeImposto} alt="" height={40} />
                                </div>
                            }
                            type={"primary"}
                            event={() => {
                                setModalDetalhesImpostosAberto(item);
                            }}
                        />
                    </Td>
                </Tr>
            );
        });
    }

    function ExportAnalise() {
        const [graficosAtivos, setGraficosAtivos] = useState({
            graficoCustoMercadoLivreMensal: true,
            tarifasCustoMercadoLivreMensal: true,
            graficosPeriodo: true,
            tarifasPeriodo: true,
        });

        const todosMarcados =
            graficosAtivos.graficoCustoMercadoLivreMensal && graficosAtivos.tarifasCustoMercadoLivreMensal && graficosAtivos.graficosPeriodo && graficosAtivos.tarifasPeriodo;

        const existeAlgumMarcado =
            graficosAtivos.graficoCustoMercadoLivreMensal || graficosAtivos.tarifasCustoMercadoLivreMensal || graficosAtivos.graficosPeriodo || graficosAtivos.tarifasPeriodo;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) =>
                        setGraficosAtivos({
                            graficoCustoMercadoLivreMensal: todosMarcados ? false : true,
                            tarifasCustoMercadoLivreMensal: todosMarcados ? false : true,
                            graficosPeriodo: todosMarcados ? false : true,
                            tarifasPeriodo: todosMarcados ? false : true,
                        })
                    }
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoCustoMensalCheckbox"
                    label="Custo Mensal (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoCustoMercadoLivreMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoCustoMercadoLivreMensal}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="tarifaCustoMensalCheckbox"
                    label="Tarifas Custo Mensal (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            tarifasCustoMercadoLivreMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.tarifasCustoMercadoLivreMensal}
                />

                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficosPeriodoCheckbox"
                    label="Custo no Período (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficosPeriodo: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficosPeriodo}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="tarifasPeriodoCheckbox"
                    label="Tarifas no Período (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            tarifasPeriodo: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.tarifasPeriodo}
                />

                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={(e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                handleExport({ graficosAtivos });
                                setExibirTabelaTarifasANEEL(false);
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => {
                                setExibirTabelaTarifasANEEL(false);
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
    listaGraficoCustoMercadoLivreMensal: state.analise.listaGraficoCustoMercadoLivreMensal,
    listaGraficoCustoMercadoLivrePeriodo: state.analise.listaGraficoCustoMercadoLivrePeriodo,
    listaGraficoCustoMercadoLivreTipo: state.analise.listaGraficoCustoMercadoLivreTipo,
    listaTarifasAneelMensal: state.analise.listaTarifasAneelMensal,
    listaTarifasAneelPeriodo: state.analise.listaTarifasAneelPeriodo,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            gerarRelatorio,
            getListaAnaliseCativoMercadoLivreMensal,
            getListaAnaliseCativoMercadoLivrePeriodo,
            atualizarListasAnaliseCativoMercadoLivrePeriodo,
        },
        dispatch
    );
const AnaliseMercadoLivre = connect(mapStateToProps, mapDispatchToProps)(analiseMercadoLivre);
export { AnaliseMercadoLivre };
